import { jsx as _jsx } from "react/jsx-runtime";
export var PlusIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, fillColor = _a.fillColor;
    var iconSize = {
        sm: 'size-4',
        md: 'size-6',
        lg: 'size-8',
    };
    return (_jsx("svg", { width: '14', height: '15', viewBox: '0 0 14 15', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M6.5625 2.6875V7.0625H2.1875V7.9375H6.5625V12.3125H7.4375V7.9375H11.8125V7.0625H7.4375V2.6875H6.5625Z', fill: fillColor ? fillColor : 'white' }) }));
};
